<script setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.3734 2.03998L21.96 0.626648L12 10.5854L2.04004 0.626648L0.626709 2.03998L10.5854 12L0.626709 21.96L2.04004 23.3734L12 13.4147L21.96 23.3734L23.3734 21.96L13.4147 12L23.3734 2.03998Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
